import { useAtom } from 'jotai';
import { InlineLoading, InlineNotification } from '@carbon/react';
import { createResourceAtom } from 'lib/atoms';
import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import type { DcaWorkspaceResponse } from 'types/dca-workspaces';
import { DcaWorkspaceContent } from './dca-workspace-content';

export const DcaWorkspacePage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const href = id ? `/dca_workspaces/${id}` : undefined;
  // const href = 'https://36d880d2-f04b-4bf0-84c3-2ef2d37a64ec.mock.pstmn.io/dca_workspaces/1'

  const resourceAtom = useMemo(
    () => createResourceAtom<DcaWorkspaceResponse>(href),
    [href]
  );
  const [resource] = useAtom(resourceAtom);

  if (!id) {
    return (
      <InlineNotification
        kind="error"
        title="Missing workspace id"
        lowContrast
      />
    );
  }

  if (resource.loading) return <InlineLoading />;

  if (resource.data && 'error' in resource.data)
    return (
      <InlineNotification
        kind="error"
        title={resource.data.error}
        lowContrast
      />
    );

  if (!resource.data)
    return (
      <InlineNotification
        kind="error"
        title="Something went wrong"
        lowContrast
      />
    );

  return <DcaWorkspaceContent workspace={resource.data} />;
};
